export interface ChatApiEndpoints {
  GET_ANSWER: 'chat/get-answer';
}

export interface ApiEndpoints {
  CHAT: ChatApiEndpoints;
}

export const API_ENDPOINTS: ApiEndpoints = {
  CHAT: {
    GET_ANSWER: 'chat/get-answer',
  }
};
